<template>
    <AdministrativeCentersFB2B v-if="isFaceB2B" :send-type="SendType" :loading="loading" />
    <AdministrativeCenters v-else :send-type="SendType" :loading="loading" />
</template>

<script>
import { i18n } from '@/i18n'
import AdministrativeCenters from '@/views/configuration/AdministrativeCenters.vue'
import AdministrativeCentersFB2B from '@/views/configuration/AdministrativeCentersFB2B.vue'
import { getSede } from '@/services/configurations/getSede'


export default {
  name: 'administrative-centers-handler',
  components: {
    AdministrativeCenters,
    AdministrativeCentersFB2B
  },
  data: function () {
    return {
      SendType: '',
      loading: false
    }
  },
  mounted () {
  },
  computed: {
    isFaceB2B: function () {
      return this.SendType === 'FACEB2B'
    },
    id () {
      return parseInt(this.$route.params.id)
    },
    idSede () {
      return parseInt(this.$route.params.idSede)
    },
  },
  async created () {
    var sendType = ''
    if (this.$store.getters['app/fromRouteName'] !== null) {
      sendType = this.$store.getters['app/stateBreadCrumb']
    } else {
      const sede = await this.downloadData()
      const cabecera = sede.LocationName || ' '
      sendType = sede.SendType
      this.$store.commit('app/setheaderBreadCrumb', cabecera)
      this.$store.commit('app/setstateBreadCrumb', sendType)
    }

    // Si NO es FACEB2B forzar remount, para carga de datos correcta.
    if (sendType !== 'FACEB2B') {
      this.loading = true
      this.SendType = 'FACEB2B'
      await this.$nextTick()
    }

    this.loading = false
    this.SendType = sendType
  },
  methods: {
    downloadData: async function () {
      let contact = null
      try {
        this.$store.commit('setIsLoading', true)

        const params = {
          IdSociedad: this.id,
          IdSede: this.idSede
        }
        contact = await getSede(params)
        if (contact.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', contact))
        } else {
          contact = contact.respuesta
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return contact
    },
  }
}
</script>
